











import { Component } from 'vue-property-decorator';
import cr from "@/CompositionRoot";
import CommonMixin from "@/utils/CommonMixin";
import EventData from "@/components/dashboard/EventData.vue";
import { EventDescription } from "frontend-common";
import EventLink from "@/components/dashboard/main/EventLink.vue";
import _ from "lodash";

@Component({
    components: {
        EventLink,
        EventData
    }
})
export default class extends CommonMixin {

    progressPublish = false

    get uuid(): string {
        return this.$route.params.uuid
    }

    get eventDescription(): EventDescription | undefined {
        return cr.myEventsModule.descriptionByUuid(this.uuid)!!
    }

    publish() {
        this.progressPublish = true
        const title = this.$t("dashboard.common.publish") as string
        const message = this.$t("dashboard.event.publish.success") as string
        cr.myEventsService.publishEvent(this.uuid)
            .then(value => this.showToast(title, message, "success"))
            .catch(reason => this.showError(reason))
            .finally(() => this.progressPublish = false)
    }

    get isEventCodeEmpty(): boolean {
        if (!this.eventDescription) {
            return true
        }

        return _.isEmpty(this.eventDescription.code)
    }

    previewLink(): string {
        return this.toPreviewEvent(cr.userModule.user?.code ?? "", this.$route.params.uuid)
    }
}
